export default __webpack_public_path__ + "static/media/dark.a6f064de.svg";